import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import classNames from 'classnames';

const ProductListSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="bg-surface-100-bg my-2.5" ref={viewRef}>
      <div className="flex flex-row relative z-10 pl-3 pt-5 pb-2">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-16 rounded-sm skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden flex pt-0" style={{ flexFlow: 'wrap' }}>
        {new Array(4).fill(0).map((_item, index) => {
          let isLeft = index / 2 === 0;
          return (
            <ProductCardSkeleton
              key={`skeleton-product-list-item-${index}`}
              className={classNames('w-6/12 box-border', { 'pl-3 pr-1.5': isLeft, 'pl-1.5 pr-3': !isLeft })}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductListSkeleton;
